import axios from "axios";
import dropdown from 'vue-dropdowns';
import noUiSlider from "nouislider";
import "./assets/css/slider.css";
const {
  ACTION,
  ACTION_ADD_TO_CART,
  PRODUCT_ID,
  PRODUCT_QUANTITY,
  LINKS,
  INITIAL_QUANTITIES,
  REQUEST_DEFAULT_CONFIG,
} = require("./parameters/RequestParameters");
const siteURL =  window.location.origin;
const attributeQuantity = "Quantity";
const attributeCategory = "Category";

axios.defaults.headers = {
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache',
  'Expires': '0',
};

export default {
  name: "App",
  components: {
    'dropdown': dropdown,
  },
  data: function() {
    return {
      product: {
        id: "",
        array: null,
        quantities:[],
        variations: 100,
        selected: {},
        initialUnitPrice: 0,
        initialQuantity: null,
        selectedCategory: null,
        selectedQuantity: null
      },
      input: {
        field: "",
      },
      icons: {
        crystal:
          "https://comprasocial.me/wp-content/uploads/2019/07/Crystal@2x.png",
        product:
          "https://comprasocial.me/wp-content/uploads/2020/12/commenti_icon.svg",
        confirm:
          "https://comprasocial.me/wp-content/uploads/2019/09/checked@2x.png",
      },
      steps: {
        isFirst: true,
        isLoading: false,
        isAddingToCart: false,
        orderCompleted: false,
      },
      dictionary: {},
    };
  },
  methods: {
    getProductInfo: async function() {
      return axios.get(this.getProductApiURL()).then((res) => {
        this.product.array = res.data.sort(function(product1, product2) {
          return product1.id < product2.id ? -1 : 1;
        });
        this.product.array.forEach(product => {
          const productQuantity = product.attributes.find(attribute => {
            return attribute.name === attributeQuantity
          }).option;
          if(!this.product.quantities.includes(productQuantity)){
            this.product.quantities.push(productQuantity);
          }
        })

        this.product.quantities.sort((a,b) => a-b);
      });
    },
    getProductApiURL: function() {
      return `https://api2.comprasocial.me/products/priceList/${this.product.id}`
    },
    getProductQuantity: function(productIndex, cleanFromDots = false) {
      if (productIndex) {
        const res = this.product.quantities[productIndex].attributes.find(
          (el) => el.name == attributeQuantity
        ).option;
        return cleanFromDots ? res.replace(".", "") : res;
      }
      if (this.product.selected && this.product.selected.attributes) {
        const res = this.product.selected.attributes.find(
          (el) => el.name == attributeQuantity
        ).option;
        return cleanFromDots ? res.replace(".", "") : res;
      }
      return 0;
    },
    generateStarForReview: function(dictionary) {
      let givenRating = dictionary.reviewValue;
      let resHtml = `<strong>${givenRating}</strong> ${dictionary.on} 5 `;
      for(let count = 0; count < 5; count++) {
        if(givenRating >= 1){
          resHtml += `<img class="cs4-star" src="${dictionary.fullStarIcon}" alt="star">`
        } else if( givenRating >= 0.5 && givenRating < 1) {
          resHtml += `<img class="cs4-star" src="${dictionary.halfStarIcon}" alt="star">`
        } else {
          resHtml += `<img class="cs4-star" src="${dictionary.emptyStarIcon}" alt="star">`
        }
        givenRating--;
      }

      resHtml += `<div class="cs4-review-section__based-on"> ${dictionary.reviewTotalNumber} ${dictionary.reviewTotalLabel}</div> `;
      return resHtml;
    },
    getProductPrice: function(productIndex) {
      if (productIndex) {
        const product = this.product.array[productIndex];
        return product.sale_price
          ? Number.parseFloat(product.sale_price).toFixed(2)
          : Number.parseFloat(product.regular_price).toFixed(2);
      }
      if (this.product.selected && this.product.selected.regular_price) {
        return this.product.selected.sale_price
          ? Number.parseFloat(this.product.selected.sale_price).toFixed(2)
          : Number.parseFloat(this.product.selected.regular_price).toFixed(2);
      }
      return (0.0).toFixed(2);
    },
    getProductCrystal: function() {
      return Math.floor(Number.parseFloat(this.getProductPrice()));
    },
    setSlider: function() {
      var slider = document.getElementById("cs4-productSlider");
      noUiSlider.create(slider, {
        start: [0],
        range: {
          min: 0,
          max: this.product.quantities.length - 1,
        },
        connect: "lower",
        tooltips: {
          to: (sliderValue) => {
            const index = Math.round(sliderValue);
            this.product.selectedQuantity = this.product.quantities[index];
            this.setSelectedProduct();
            return `<img class="cs4-product-icon" src="${
              this.icons.product
            }"/> +${this.product.selectedQuantity}`;
          },
        },
        step: 1,
      });
    },
    setSelectedProduct: function(){
      this.product.selected = this.product.array.find((product) => {
        const serviceQuantity = product.attributes.find((attribute) => attribute.name === attributeQuantity).option;
        const serviceCategory = product.attributes.find((attribute) => attribute.name === attributeCategory).option;
        return serviceQuantity === this.product.selectedQuantity && serviceCategory === this.product.selectedCategory.name;
      });
    },
    cleanInputField() {
      this.input.field = this.input.field.replace(" ", "");
      this.input.field = this.input.field.replace(
        new RegExp(".*instagram.com/"),
        ""
      );
      this.input.field = this.input.field.replace(new RegExp("\\?.*"), "");
    },
    goToFirstStep() {
      this.product.selected = {};
      this.product.initialQuantity = null;
      this.input.field = "";
      this.steps.isAddingToCart = false;
      this.steps.orderCompleted = false;
      this.steps.isFirst = true;
      setTimeout(() => this.setSlider(), 100);
    },
    increaseCartItemCounter() {
      const cartItemCounter = document.getElementById("cs-header__cartCounter");
      cartItemCounter.innerText = parseInt(cartItemCounter.innerText) + 1;
    },
    addProductToCart: async function() {
      if(this.input.field.replace(" ", "") === "") {
        const inputField = document.getElementById("inputField");
        inputField.classList.add("errorBounce");
        setTimeout(function(){
          inputField.classList.remove("errorBounce");
        }, 1000)
      } else {
        this.onToggleProductToCart();
        const productRequestFormData = this.createAddToCartRequestBody( this.product.selected.id, this.input.field,null );
        await this.runAddToCartRequest(productRequestFormData);
        this.increaseCartItemCounter();
        this.onToggleProductToCart();
      }
    },
    onToggleProductToCart() {
      if (this.steps.isAddingToCart) {
        this.steps.isLoading = false;
        this.steps.isAddingToCart = false;
        this.steps.orderCompleted = true;
      } else {
        this.steps.isLoading = true;
        this.steps.isSecond = false;
        this.steps.isFirst = false;
        this.steps.isSecondPhotoURL = false;
        this.steps.isSecondUsername = false;
        this.steps.isAddingToCart = true;
      }
    },
    createAddToCartRequestBody(productId, links, initQuantities) {
      const formBody = new URLSearchParams();
      formBody.append(ACTION, ACTION_ADD_TO_CART);
      formBody.append(PRODUCT_ID, productId);
      formBody.append(PRODUCT_QUANTITY, 1);
      formBody.append(LINKS, links);
      if (initQuantities !== null) {
        formBody.append(INITIAL_QUANTITIES, initQuantities);
      }
      return formBody;
    },
    runAddToCartRequest(requestBody) {
      // eslint-disable-next-line no-undef
      return axios.post( wc_add_to_cart_params.ajax_url, requestBody, REQUEST_DEFAULT_CONFIG);
    },
    onCategorySelect(payload) {
      this.product.selectedCategory = payload;
      this.setSelectedProduct();
    },
    continueToBuy() {
      this.goToFirstStep();
    },
    goToCheckout(){
      const cartButton = document.getElementsByClassName('cs-header__cartWrapper')[0];
      cartButton.click();
    },
  },
  mounted: function() {
    this.steps.isFirst = false;
    this.steps.isLoading = true;
    // eslint-disable-next-line no-undef
    axios.get( siteURL + '/wp-content/themes/cs-theme/assets/sliders-dictionaries/instagram/comments-reels/dictionary-' + currentLanguage + '.json').then((res) => {
      this.dictionary = res.data;
      this.product.id = this.dictionary.productID;
      this.steps.isFirst = true;
      this.steps.isLoading = false;
      this.product.selectedCategory = this.dictionary.commentOptions[0];
      this.getProductInfo().then(() => {
        this.setSlider();
        this.setSelectedProduct();
      });
    });
  },
};
